import ConfirmationModal from "components/common/custom/confirmation-modal";
import {
  handleAddClaimServices,
  resetSelectedService,
  setHistoryModal,
  setSelectedService,
  setViewModal,
} from "features/cliams/config/claimSlice";
import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import { Button, Col, Row } from "react-bootstrap";
import { Eye, Gear, Pen, Plus } from "react-bootstrap-icons";
import DataTable from "react-data-table-component";
import { MdDelete } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
import { GetAllServiceCodeDescription } from "../../../../preauthorization/config/preauthorizationApi";
import { timeInstruction } from "../../../../preauthorization/components/ServicesProcedures";

const ClaimServicesProcedures = () => {
  const dispatch = useDispatch();
  const {
    cliamServicesList,
    stepFormData,
    claimServicesList,
    practitionerListAdded,
  } = useSelector((state) => state.claim);

  const {
    bodySite,
    scientificAbsnceReason,
    routeList,
    bodySubSite,
    serviceTypeList,
    viewPreauthorizationInfo,
    oralDentalList,
    substituteReason,
    selectReasonList,
  } = useSelector((state) => state.preauthorization);

  console.log({ practitionerListAdded });

  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [searchParams] = useSearchParams();
  const [invoiceUpdates, setInvoiceUpdates] = useState({});
  const [preauthUpdates, setPreauthUpdates] = useState({});

  const servRef = useRef();

  const preauth = searchParams.get("preauth") === "true";
  const selectedBranch = JSON.parse(localStorage.getItem("selectedBranch"));
  const daySupplyInfo =
    viewPreauthorizationInfo?.provider_request?.sup_info_suply;

  const providerServices =
    viewPreauthorizationInfo?.provider_request?.service_procedures || [];

  useEffect(() => {
    if (!providerServices?.length || servRef.current || !preauth) {
      return;
    }

    servRef.current = true;

    const loadServices = async () => {
      try {
        const transformed = await Promise.all(
          providerServices?.map(async (item, index) => {
            console.log({ item });

            const dosageData = item?.medication_request?.dosage_instruction;
            const duration = dosageData?.duration?.split("-");
            const frequency = dosageData?.frequency?.split(" ");
            const freqDetails = frequency?.[0]?.split("-");
            const doseDetails = dosageData?.dose?.split(" ");
            let medicationRequest = null;
            const netAmount = parseFloat(Number(item.servinfo_prdnamnt) || 0);
            const patientShare = parseFloat(
              Number(item.servinfo_prdpshre) || 0,
            );
            const unitPrice = parseFloat(Number(item.servinfo_prdpri) || 0);
            const quantity = parseFloat(
              Number(item.servinfo_prdqty || item?.apprv_qty) || 1,
            );
            const discount = parseFloat(Number(item.servinfo_prddisc) || 0);

            const response = await dispatch(
              GetAllServiceCodeDescription({
                branch_id:
                  selectedBranch?.branch_id || selectedBranch?.value || "",
                prd_typ: item?.prdtypcde || item?.prdtyp,
                prodserv_id: item?.itemcode,
                ins_sel: stepFormData?.payer?.insurance_company_id,
                claim_type: stepFormData?.claim_type?.claim_types_id,
                is_prescription: stepFormData?.prescription || false,
              }),
            ).unwrap();

            if (
              item?.presmed ||
              item?.medication_request?.medicationrequest_code
            ) {
              const res = await dispatch(
                GetAllServiceCodeDescription({
                  branch_id:
                    selectedBranch?.branch_id || selectedBranch?.value || "",
                  prd_typ: "itm_prdt",
                  prodserv_id:
                    item?.presmed ||
                    item?.medication_request?.medicationrequest_code,
                  ins_sel: stepFormData?.payer?.insurance_company_id,
                  claim_type: stepFormData?.claim_type?.claim_types_id,
                  is_prescription: stepFormData?.prescription || false,
                }),
              ).unwrap();
              const resServData = res?.data?.Service_Code?.[0] || {};
              medicationRequest = {
                prodserv_code: resServData?.prodserv_code,
                prodserv_desc: resServData?.prodserv_desc,
                provider_code: resServData?.provider_code || "",
                unit_price: resServData?.unit_price || 0,
                price_discount: resServData?.price_discount || 0,
                price_tax: resServData?.price_tax || "15",
                provider_codedesc: resServData?.provider_codedesc || "",
                prdurl: resServData?.prdurl || "",
                prodserv_unittyp: resServData?.prodserv_unittyp || "",
                prodserv_pcksze: resServData?.prodserv_pcksze || "",
                prodserv_strngt: resServData?.prodserv_strngt || "",
                value: resServData?.value,
                label: resServData?.label,
              };
            }

            const servData = response?.data?.Service_Code?.[0] || {};

            return {
              id: `service-${item.itemcode}-${item.dateserv}-${index}`,
              service_start_date:
                item.dateserv || moment().format("YYYY-MM-DD"),
              service_end_date: item.dateserv || moment().format("YYYY-MM-DD"),

              service_type: serviceTypeList?.find(
                (serv) => serv?.servtype_code === item?.prdtypcde,
              ),

              service_code_description: {
                prodserv_code: servData?.prodserv_code,
                prodserv_desc: servData?.prodserv_desc,
                provider_code: servData?.provider_code || "",
                unit_price: servData?.unit_price || 0,
                price_discount: servData?.price_discount || 0,
                price_tax: servData?.price_tax || "15",
                provider_codedesc: servData?.provider_codedesc || "",
                prdurl: servData?.prdurl || "",
                prodserv_unittyp: servData?.prodserv_unittyp || "",
                prodserv_pcksze: servData?.prodserv_pcksze || "",
                prodserv_strngt: servData?.prodserv_strngt || "",
                value: servData?.value,
                label: servData?.label,
              },

              quantity,
              unit_price: unitPrice,
              discount,
              patient_share: patientShare,
              net_amount: netAmount,

              vat: item.servinfo_prdtax === "15" ? "15" : "0",

              raw: item,

              service_practitioner: practitionerListAdded?.find(
                (pract) =>
                  String(pract?.id) == item?.servinfo_pract ||
                  pract?.practitioner?.value?.practitioner_id,
              )?.practitioner,

              diagnosis: item.servinfo_diag
                ? [{ code: item.servinfo_diag, name: item.servinfo_diagname }]
                : [],

              maternity: item.matrnty?.toLowerCase() === "yes",
              body_site: item?.bodysite
                ? bodySite?.find((b) => b?.bodysite_code === item?.bodysite)
                : null,
              sub_site: item?.subsite
                ? bodySubSite?.find(
                    (b) => b?.bodysubsite_code === item?.subsite,
                  )
                : null,
              oral_origin: item?.toothno
                ? oralDentalList?.find(
                    (item) => item?.oral_code === item?.toothno,
                  )
                : null,
              day_supply: daySupplyInfo?.[index]?.qty,

              prescribed_medication_type: serviceTypeList?.find(
                (serv) => serv?.servtype_code === item?.presmedtyp,
              ),
              prescribed_medication_code: medicationRequest,
              strength:
                item?.prdtypcde == "itm_prdt" || item?.prdtypcde == "itm_meddev"
                  ? ""
                  : item?.pharstrnth,
              selection_reason: selectReasonList?.find(
                (reason) => reason?.pharmselrsn_code === item?.pharslrsn,
              ),
              pharmacist_substitute: substituteReason?.find(
                (sub) => sub?.subsrsn_code === item?.pharsubs,
              ),
              scientic_code_absence: scientificAbsnceReason?.find(
                (abs) => abs?.absrsn_code === item?.pharscabrsn,
              ),
              scientific_code_other_reason: item?.pharscabrsn_oth || "",
              substitute_reason_other: item?.pharsubs_oth || "",
              route: routeList?.find(
                (route) => route?.ruteadmn_code === dosageData?.route_code,
              ),
              start_date: dosageData?.period_start
                ? new Date(dosageData?.period_start)
                : "",
              end_date: dosageData?.period_end
                ? new Date(dosageData?.period_end)
                : "",
              refill_count: dosageData?.refill || "",
              patient_instruction: dosageData?.patient_instruction || "",
              dosage_instruction: dosageData?.text || "",
              time_instruction: timeInstruction?.find(
                (inst) =>
                  inst?.time_instCode === dosageData?.time_instruction_code,
              ),
              duration: duration?.[0] || "",
              durationType: duration?.[1] || "",
              frequency: freqDetails?.[0] || "",
              period_info: freqDetails?.[1] || "",
              period_type: frequency?.[1] || "",
              dose: doseDetails?.[0] || "",
              dose_type: doseDetails?.[1] || "",
            };
          }),
        );

        // Add all transformed services to Redux if not already present
        transformed.forEach((service) => {
          const exists = claimServicesList?.some((s) => s.id === service.id);
          if (!exists) {
            dispatch(
              handleAddClaimServices({
                type: "ADD_SERVICES",
                payload: service,
              }),
            );
          }
        });
      } catch (error) {
        console.error("Error loading preauthorization services:", error);
      }
    };

    loadServices();
  }, [providerServices, stepFormData, preauth]);

  const handleInvoiceChange = (id, value) => {
    setInvoiceUpdates((prev) => ({
      ...prev,
      [id]: value,
    }));
    dispatch(
      handleAddClaimServices({
        type: "UPDATE_INVOICE_NO",
        payload: { id, invoice_no: value },
      }),
    );
  };

  const handlePreauthRefNoChange = (id, value) => {
    setPreauthUpdates((prev) => ({
      ...prev,
      [id]: value,
    }));
    dispatch(
      handleAddClaimServices({
        type: "UPDATE_PREAUTH_REF_NO",
        payload: { id, preauthorization_ref_no: value },
      }),
    );
  };
  const editModal = (id, row) => {
    dispatch(setSelectedService(row));
    dispatch(setViewModal(false));
    dispatch(setHistoryModal(true));
  };

  const viewModal = (id, row) => {
    dispatch(setSelectedService(row));
    dispatch(setHistoryModal(true));
    dispatch(setViewModal(true));
  };

  const handleDeleteClick = (id) => {
    setDeleteId(id);
    setShowDeleteModal(true);
  };

  const handleConfirmDelete = () => {
    if (deleteId) {
      dispatch(
        handleAddClaimServices({
          type: "DELETE_SERVICES",
          payload: { id: deleteId },
        }),
      );
      setShowDeleteModal(false);
      setDeleteId(null);
    }
  };

  const columns = [
    {
      name: "#",
      sortable: false,
      selector: (_, index) => (
        <div className="d-flex justify-content-center align-items-center">
          <div
            className="rounded-circle bg-200 d-flex flex-center fs-11"
            style={{ width: "20px", height: "20px" }}
          >
            {index + 1}
          </div>
        </div>
      ),
    },
    {
      name: "Date",
      sortable: false,
      selector: (row) =>
        row?.service_start_date
          ? moment(row.service_start_date).format("DD-MM-YYYY")
          : "",
    },
    {
      name: <div>Service Code / Description</div>,
      sortable: false,
      cell: (row) => {
        const code =
          row?.service_code_description?.value ||
          row?.service_code_description?.prodserv_code ||
          "";
        const desc =
          row?.service_code_description?.label ||
          row?.service_code_description?.prodserv_desc ||
          "";
        const providerCode = row?.service_code_description?.provider_code || "";
        const providerDesc =
          row?.service_code_description?.provider_codedesc || "";

        return (
          <div className="fs-11">
            <div className="text-primary">
              <strong>{code}</strong> - {desc}
            </div>
            {(providerCode || providerDesc) && (
              <div className="text-danger fs-11">
                {providerCode} - {providerDesc}
              </div>
            )}
          </div>
        );
      },
      width: "14rem",
    },
    {
      name: "Invoice No.",
      sortable: false,
      cell: (row) => {
        const currentValue = row.invoice_no || invoiceUpdates[row.id] || "";
        return preauth ? (
          <input
            type="text"
            className="form-control form-control-sm"
            value={currentValue}
            onChange={(e) => handleInvoiceChange(row.id, e.target.value)}
            placeholder="Enter invoice number"
          />
        ) : (
          currentValue
        );
      },
    },

    {
      name: "Preauth Ref No",
      sortable: false,
      cell: (row) => {
        const currentValue =
          row.preauthorization_ref_no || preauthUpdates[row.id] || "";

        return preauth ? (
          <input
            type="text"
            className="form-control form-control-sm"
            value={currentValue}
            onChange={(e) => handlePreauthRefNoChange(row.id, e.target.value)}
            placeholder="Enter Preauth Ref No"
          />
        ) : (
          row?.preauthorization_ref_no
        );
      },
    },

    {
      name: "Quantity",
      sortable: false,
      selector: (row) => row?.quantity || 0,
    },
    {
      name: "Unit Price",
      sortable: false,
      selector: (row) => row?.unit_price || 0,
    },
    {
      name: "Discount",
      sortable: false,
      selector: (row) => row?.discount || 0,
    },
    {
      name: "Patient Share",
      sortable: false,
      selector: (row) => row?.patient_share || 0,
    },
    {
      name: "Net Amount",
      sortable: false,
      selector: (row) => row?.net_amount || 0,
    },
    {
      name: <Gear />,
      button: true,
      allowOverflow: true,
      cell: (row) => (
        <div className="d-flex align-items-center gap-2">
          <Eye
            onClick={() => viewModal(row.id, row)}
            size={20}
            className="text-primary leaflet-interactive"
          />
          <Pen
            onClick={() => editModal(row.id, row)}
            size={20}
            className="text-warning leaflet-interactive"
          />
          <MdDelete
            onClick={() => handleDeleteClick(row.id)}
            size={20}
            className="text-danger leaflet-interactive"
          />
        </div>
      ),
    },
  ];

  return (
    <Row className="">
      <Col xs={12} className="d-flex justify-content-end">
        <Button
          variant="success"
          size="sm"
          onClick={() => {
            dispatch(setHistoryModal(true));
            dispatch(resetSelectedService());
          }}
        >
          <Plus /> Add Services
        </Button>
      </Col>
      <hr className="mt-2" />
      {cliamServicesList?.length > 0 ? (
        <Col xs={12}>
          <DataTable
            data={cliamServicesList}
            columns={columns}
            responsive
            customStyles={{
              table: { style: { overflow: "visible" } },
              rows: { style: { overflow: "visible" } },
            }}
          />
        </Col>
      ) : (
        <div className="d-flex border py-4 rounded text-danger fs-9 fw-bold justify-content-center">
          No services added
        </div>
      )}
      <ConfirmationModal
        modal={showDeleteModal}
        setModal={setShowDeleteModal}
        onConfirm={handleConfirmDelete}
        title="Confirm Delete"
        description="Are you sure you want to delete this service?"
      />
    </Row>
  );
};

export default ClaimServicesProcedures;
